import omit from './omit'

export { omit }
export default omit
